import { Node, Transforms } from 'slate';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { A as AppMultiSwitchOptions } from './MultipleSwitchSelectionComponent-88d36c19.esm.js';

const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code"
};
const LIST_TYPES = ["numbered-list", "bulleted-list"];
const TEST_INTENTS = [{
  id: "INT_CONS",
  label: "Consultation"
}, {
  id: "INT_PROB",
  label: "Problem"
}, {
  id: "INT_SOL",
  label: "Solution"
}, {
  id: "INT_HTACT",
  label: "Hearing tactic"
}];
const META_TARGETS = [{
  id: "TAG",
  label: "Tag",
  key: "#",
  backgroundColor: "blue",
  color: "white"
}, {
  id: "MENTION",
  label: "Mention",
  key: "@",
  backgroundColor: "purple",
  color: "white"
}];
const NLP_OPTIONS = [{
  id: "IMP_SELF",
  label: "SelfNLPCaption",
  logicalPropertyName: "isImplicitSelfEnabled"
}, {
  id: "SENT_SPLIT",
  label: "SplitNLPCaption",
  logicalPropertyName: "isSentenceSplitEnabled"
}];
const NLP_TIMER = 500;
const RELAY_TIMER = 2000;
const MENTIONS_EXTRACTION_TIMER = 1000;
const MARKS_EXTRACTION_TIMER = 1000;
const CONTEXT_TIMER = 1000;
const MAX_CONTEXT_SIZE = 1200;
const MIN_WORDS_FOR_NLP = 2;
const INTENT_PROPERTY = "INTENT";
const TIME_PROPERTY = "TIME";
const PERSON_PROPERTY = "PERSON";
const WHAT_PROPERTY = "WHAT";
const LANG_PROPERTY = "LANGUAGE";
const ASSIGN_PROPERTY = "ASSIGNEE";
const RAW_DATA_PROPERTY = "RAW_DATA";
const DUE_DATE_PROPERTY = "DUE_DATE";
const IMPLICIT_SELF_PRONOUNS = ["I"];
const STATUS_PROPERTY = "STATUS";
const PRIORITY_OPTION = "PRIORITY";
const ANSWER_PROPERTY = "ANSWER";
const ANSWERS_PROPERTY = "ANSWERS";
const ANSWER_TRAINED_PROPERTY = "ANSWER_TRAINED";
const QUESTION_TRAINED_PROPERTY = "QUESTION_TRAINED";
const COMPLETION_TRAINED_PROPERTY = "COMPLETION_TRAINED";
const NON_PREFERRED_COMPLETION_TRAINED_PROPERTY = "NON_PREFERRED_COMPLETION_TRAINED";
const ANSWER_IN_CONTEXT_PROPERTY = "ANSWER_IN_CONTEXT";
const PROMPT_PROPERTY = "PROMPT_TRAINED";
const SYS_PROMPT_PROPERTY = "SYS_PROMPT";
const CONTEXT_PROPERTY = "CONTEXT";
const IS_CONTEXT_FORCED = "IS_CONTEXT_FORCED";
const ROLE_PROPERTY = "ROLE";
const IS_DPO_PROPERTY = "IS_DPO";
const EDITOR_ICON_SIZE = 18;
const INTENT_TOOLBAR_OPTIONS = [{
  isNavigation: false,
  icon: AppAssets.icons.export,
  onPress: opt => {},
  uid: "HTML_EXPORT",
  label: "Export to HTML"
}, {
  isNavigation: false,
  icon: AppAssets.icons.generateEmail,
  onPress: opt => {},
  uid: "EMAIL_EXPORT",
  label: "Generate email"
}, {
  isNavigation: true,
  icon: AppAssets.icons.settings,
  onPress: opt => {},
  uid: "SETTINGS",
  label: "Set analysis preferences",
  children: AppMultiSwitchOptions,
  subOptions: NLP_OPTIONS.map(u => ({
    id: u.id,
    title: u.label,
    ticked: false,
    uid: "SETTINGS",
    onPress: u => {}
  }))
}];
const HIGHLIGHTS_COLOURS = [{
  id: 1,
  color: "white",
  format: "highlightTransparent",
  icon: AppAssets.icons.highlight
}, {
  id: 2,
  color: "red",
  format: "highlightRed",
  icon: AppAssets.icons.highlight
}, {
  id: 3,
  color: "blue",
  format: "highlightBlue",
  icon: AppAssets.icons.highlight
}, {
  id: 4,
  color: "green",
  format: "highlightGreen",
  icon: AppAssets.icons.highlight
}, {
  id: 5,
  color: "yellow",
  format: "highlightYellow",
  icon: AppAssets.icons.highlight
}];
const FONT_COLOURS = [{
  id: 1,
  color: "white",
  format: "fontTransparent",
  icon: AppAssets.icons.fontColor
}, {
  id: 2,
  color: "red",
  format: "fontRed",
  icon: AppAssets.icons.fontColor
}, {
  id: 3,
  color: "blue",
  format: "fontBlue",
  icon: AppAssets.icons.fontColor
}, {
  id: 4,
  color: "green",
  format: "fontGreen",
  icon: AppAssets.icons.fontColor
}, {
  id: 5,
  color: "yellow",
  format: "fontYellow",
  icon: AppAssets.icons.fontColor
}];
var QuantumConfig = {
  HOTKEYS,
  LIST_TYPES,
  TEST_INTENTS,
  NLP_OPTIONS,
  ANSWER_IN_CONTEXT_PROPERTY,
  INTENT_PROPERTY,
  TIME_PROPERTY,
  CONTEXT_TIMER,
  MAX_CONTEXT_SIZE,
  PERSON_PROPERTY,
  WHAT_PROPERTY,
  LANG_PROPERTY,
  RAW_DATA_PROPERTY,
  NLP_TIMER,
  MIN_WORDS_FOR_NLP,
  IMPLICIT_SELF_PRONOUNS,
  ASSIGN_PROPERTY,
  DUE_DATE_PROPERTY,
  STATUS_PROPERTY,
  PRIORITY_OPTION,
  META_TARGETS,
  MENTIONS_EXTRACTION_TIMER,
  INTENT_TOOLBAR_OPTIONS,
  HIGHLIGHTS_COLOURS,
  FONT_COLOURS,
  RELAY_TIMER,
  ANSWER_PROPERTY,
  ANSWERS_PROPERTY,
  MARKS_EXTRACTION_TIMER,
  ANSWER_TRAINED_PROPERTY,
  EDITOR_ICON_SIZE,
  QUESTION_TRAINED_PROPERTY,
  CONTEXT_PROPERTY,
  COMPLETION_TRAINED_PROPERTY,
  NON_PREFERRED_COMPLETION_TRAINED_PROPERTY,
  PROMPT_PROPERTY,
  SYS_PROMPT_PROPERTY,
  IS_CONTEXT_FORCED,
  ROLE_PROPERTY,
  IS_DPO_PROPERTY
};

const getPlainText = function (editor) {
  let includeTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let includeParagraphMarker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let returnArray = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const baseArray = editor.map(n => {
    if ((n === null || n === void 0 ? void 0 : n.type) === "bulleted-list" || (n === null || n === void 0 ? void 0 : n.type) === "numbered-list") {
      const listItems = [];
      for (let i = 0; i < (n === null || n === void 0 ? void 0 : (_n$children = n.children) === null || _n$children === void 0 ? void 0 : _n$children.length); i++) {
        var _n$children;
        const child = n === null || n === void 0 ? void 0 : n.children[i];
        if ((child === null || child === void 0 ? void 0 : child.type) === "list-item") {
          var _child$children, _child$children$;
          if ((child === null || child === void 0 ? void 0 : (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.length) > 0) listItems.push("- ".concat(child === null || child === void 0 ? void 0 : (_child$children$ = child.children[0]) === null || _child$children$ === void 0 ? void 0 : _child$children$.text, "\n"));else continue;
        }
      }
      return listItems.join(" ");
    } else if (((n === null || n === void 0 ? void 0 : n.type) !== "title" || includeTitle) && (n === null || n === void 0 ? void 0 : n.type) !== "editable-void") return "".concat(Node.string(n), "\n");else {
      return "";
    }
  });
  if (returnArray) return baseArray;
  return baseArray.join(includeParagraphMarker ? " \n " : " ");
};
const slateToMarkdown = blocks => {
  let markdown = "";
  function processChild(child) {
    let text = child.text;
    if (child.bold) text = "**".concat(text, "**");
    if (child.italic) text = "*".concat(text, "*");
    if (child.underline) text = "__".concat(text, "__");
    if (child.code) text = "`".concat(text, "`");
    if (child.type === "link") text = "[".concat(text, "](").concat(child.url, ")");
    return text;
  }
  blocks.forEach(block => {
    switch (block.type) {
      case "paragraph":
        block.children.forEach(child => {
          markdown += processChild(child);
        });
        markdown += "\n\n";
        break;
      case "numbered-list":
        let count = 1;
        block.children.forEach(child => {
          markdown += "".concat(count, ". ").concat(processChild(child.children[0]), "\n");
          count++;
        });
        markdown += "\n";
        break;
      case "bulleted-list":
        block.children.forEach(child => {
          markdown += "- ".concat(processChild(child.children[0]), "\n");
        });
        markdown += "\n";
        break;
      case "block-quote":
        block.children.forEach(child => {
          markdown += "> ".concat(processChild(child), "\n");
        });
        markdown += "\n";
        break;
      case "heading-one":
        block.children.forEach(child => {
          markdown += "# ".concat(processChild(child), "\n\n");
        });
        break;
      case "heading-two":
        block.children.forEach(child => {
          markdown += "## ".concat(processChild(child), "\n\n");
        });
        break;
      case "image":
        markdown += "![Image](".concat(block.url, ")\n\n");
        break;
      case "title":
        block.children.forEach(child => {
          markdown += "# ".concat(processChild(child), "\n\n");
        });
        break;
      default:
        console.log("Unknown block type \"".concat(block.type, "\""));
        break;
    }
  });
  return markdown;
};
const extractTrainingData = function (editor, entityType) {
  let scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ALL";
  const NERData = extractEntitiesByType(editor, entityType);
  const IntentData = extractIntents(editor);
  const trainingData = groupEntitiesAndIntentByID(NERData, IntentData, editor, scope);
  return {
    trainingData,
    entitiesMap: NERData.map(u => u.location),
    intentsMap: IntentData
  };
};
const extractRcTrainingData = editor => {
  const RcData = extractRcData(editor);
  return {
    trainingData: RcData
  };
};
const extractGnTrainingData = editor => {
  const GnData = extractGnData(editor);
  return {
    trainingData: GnData
  };
};
const extractCnTrainingData = editor => {
  const GnData = extractCnData(editor);
  return {
    trainingData: GnData
  };
};
const extractIntents = editor => {
  const matchingIntent = [];
  for (let i = 0; i < (editor === null || editor === void 0 ? void 0 : editor.children.length); i++) {
    const block = editor === null || editor === void 0 ? void 0 : editor.children[i];
    if (block.type === "numbered-list" || block.type === "bulleted-list") {
      for (let j = 0; j < (block === null || block === void 0 ? void 0 : (_block$children = block.children) === null || _block$children === void 0 ? void 0 : _block$children.length); j++) {
        var _block$children, _enrichedNode$INTENT;
        const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, j, ["ner"]);
        matchingIntent.push({
          blockIndex: i,
          nestedIndex: j,
          intent: enrichedNode.INTENT ? (_enrichedNode$INTENT = enrichedNode.INTENT) === null || _enrichedNode$INTENT === void 0 ? void 0 : _enrichedNode$INTENT.map(u => u.name) : [""],
          path: [i, j]
        });
      }
    } else {
      var _enrichedNode$INTENT2;
      const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, -1, ["ner"]);
      matchingIntent.push({
        blockIndex: i,
        intent: enrichedNode.INTENT ? (_enrichedNode$INTENT2 = enrichedNode.INTENT) === null || _enrichedNode$INTENT2 === void 0 ? void 0 : _enrichedNode$INTENT2.map(u => u.name) : [""],
        path: [i]
      });
    }
  }
  return matchingIntent;
};
const getStartIndex = (blockIndexesUsedForContext, editor, blockIndex) => {
  const startOfContextAsIndex = Math.min(...blockIndexesUsedForContext);
  const endOfContextAsIndex = Math.max(...blockIndexesUsedForContext);
  const subEditor = editor.children.slice(startOfContextAsIndex, endOfContextAsIndex);
  const afterPassage = editor.children.slice(blockIndex, endOfContextAsIndex);
  contextLenght = getPlainText(subEditor, false).length;
  afterQuestionLength = getPlainText(afterPassage, false).length;
  const startIndex = endOfContextAsIndex > blockIndex ? contextLenght - afterQuestionLength > 0 ? contextLenght - afterQuestionLength : 0 : 0;
  // force this behavior for now to prevent the start index to go beyond the size of the text
  return startIndex < contextLenght ? startIndex : 0;
};
const cleanPunctuation = text => {
  if (text.slice(-1) !== "." && text.slice(-1) !== "?" && text.slice(-1) !== "!" && text.slice(-1) !== ";" && text.slice(-1) !== ":" && text.slice(-1) !== ")" && text.slice(-1) !== "]" && text.slice(-1) !== "}") {
    text += ".";
  }
  return text;
};
const verifyAnswerIsValid = (editor, enrichedNode, path, _context) => {
  var _enrichedNode$Constan;
  if ((_context === null || _context === void 0 ? void 0 : _context.length) < ((_enrichedNode$Constan = enrichedNode[QuantumConfig.ANSWER_TRAINED_PROPERTY]) === null || _enrichedNode$Constan === void 0 ? void 0 : _enrichedNode$Constan.length)) {
    Transforms.setNodes(editor, {
      IS_VALID: false
    }, {
      at: path
    });
    return false;
  } else {
    Transforms.setNodes(editor, {
      IS_VALID: true
    }, {
      at: path
    });
    return true;
  }
};
const verifyPromptIsValid = (editor, enrichedNode, path, _context) => {
  var _prompt2, _enrichedNode$Constan2;
  _prompt = enrichedNode[QuantumConfig.PROMPT_PROPERTY] || _context;
  if (((_prompt2 = _prompt) === null || _prompt2 === void 0 ? void 0 : _prompt2.length) > 5000 || ((_enrichedNode$Constan2 = enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]) === null || _enrichedNode$Constan2 === void 0 ? void 0 : _enrichedNode$Constan2.length) > 5000) {
    Transforms.setNodes(editor, {
      IS_VALID: false
    }, {
      at: path
    });
    return false;
  } else {
    Transforms.setNodes(editor, {
      IS_VALID: true
    }, {
      at: path
    });
    return true;
  }
};
const getTextAroundIndex = function (i, editor) {
  var _editor$children;
  let beforeOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let context = "";
  let blockIndexesUsedForContext = [];
  let startIndex = 0;
  const editorLength = editor === null || editor === void 0 ? void 0 : (_editor$children = editor.children) === null || _editor$children === void 0 ? void 0 : _editor$children.length;
  let elementBefore, elementAfter;
  for (let j = 1; j < 1000; j++) {
    var _elementBefore, _elementBefore2, _elementAfter, _elementBefore3;
    elementBefore = null;
    elementAfter = null;
    // Populate the elements before and after the index
    if (i - j >= 0 && i - j < editorLength) elementBefore = editor.children[i - j];
    if (editorLength >= i + j) elementAfter = editor.children[i + j];
    // If the element before is a paragraph and it has less than 1200 characters summed with context, we add it otherwise we can stop
    if (elementBefore && (((_elementBefore = elementBefore) === null || _elementBefore === void 0 ? void 0 : _elementBefore.type) === "paragraph" || !((_elementBefore2 = elementBefore) !== null && _elementBefore2 !== void 0 && _elementBefore2.type))) {
      var _context2;
      if (((_context2 = context) === null || _context2 === void 0 ? void 0 : _context2.length) + generateStringFromElement(elementBefore).length < QuantumConfig.MAX_CONTEXT_SIZE) {
        context = "".concat(cleanPunctuation(generateStringFromElement(elementBefore)), " ").concat(context);
        blockIndexesUsedForContext.push(i - j);
        startIndex = getStartIndex(blockIndexesUsedForContext, editor, i);
      } else {
        startIndex = getStartIndex(blockIndexesUsedForContext, editor, i);
        break;
      }
    }
    // if (beforeOnly && elementBefore?.type === "editable-void") break;
    // If the element after is a paragraph and it has less than 1200 characters summed with context, we add it otherwise we can stop
    if (!beforeOnly && elementAfter && (((_elementAfter = elementAfter) === null || _elementAfter === void 0 ? void 0 : _elementAfter.type) === "paragraph" || !((_elementBefore3 = elementBefore) !== null && _elementBefore3 !== void 0 && _elementBefore3.type))) {
      var _context3;
      if (((_context3 = context) === null || _context3 === void 0 ? void 0 : _context3.length) + generateStringFromElement(elementAfter).length < QuantumConfig.MAX_CONTEXT_SIZE) {
        context = "".concat(context, " ").concat(cleanPunctuation(generateStringFromElement(elementAfter)));
        blockIndexesUsedForContext.push(i + j);
        startIndex = getStartIndex(blockIndexesUsedForContext, editor, i);
      } else {
        startIndex = getStartIndex(blockIndexesUsedForContext, editor, i);
        break;
      }
    }
  }
  return {
    context,
    blockIndexesUsedForContext,
    startIndex
  };
};
const extractRcData = editor => {
  const qaData = [];
  getPlainText(editor === null || editor === void 0 ? void 0 : editor.children, false, false);
  for (let i = 0; i < (editor === null || editor === void 0 ? void 0 : editor.children.length); i++) {
    const block = editor === null || editor === void 0 ? void 0 : editor.children[i];
    let forcedContext;
    if (block.type === "numbered-list" || block.type === "bulleted-list") {
      for (let j = 0; j < (block === null || block === void 0 ? void 0 : (_block$children2 = block.children) === null || _block$children2 === void 0 ? void 0 : _block$children2.length); j++) {
        var _block$children2;
        const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, j, ["ner"]);
        if (enrichedNode.type === "editable-void") {
          var _enrichedNode$Constan3, _enrichedNode$Constan4, _context$trim;
          const {
            context,
            blockIndexesUsedForContext,
            startIndex
          } = getTextAroundIndex(i, editor);
          if (((_enrichedNode$Constan3 = enrichedNode[QuantumConfig.CONTEXT_PROPERTY]) === null || _enrichedNode$Constan3 === void 0 ? void 0 : (_enrichedNode$Constan4 = _enrichedNode$Constan3.trim()) === null || _enrichedNode$Constan4 === void 0 ? void 0 : _enrichedNode$Constan4.length) > 0) forcedContext = enrichedNode[QuantumConfig.CONTEXT_PROPERTY];
          const _context = forcedContext || context;
          if (verifyAnswerIsValid(editor, enrichedNode, [i, j], _context)) qaData.push({
            blockIndex: i,
            nestedIndex: j,
            context: _context,
            blockIndexesUsedForContext,
            is_impossible: enrichedNode[QuantumConfig.ANSWER_IN_CONTEXT_PROPERTY] === false || !((_context === null || _context === void 0 ? void 0 : (_context$trim = _context.trim()) === null || _context$trim === void 0 ? void 0 : _context$trim.length) > 0),
            question: enrichedNode[QuantumConfig.QUESTION_TRAINED_PROPERTY],
            answer: enrichedNode[QuantumConfig.ANSWER_TRAINED_PROPERTY],
            startIndex: forcedContext ? 0 : startIndex
          });
        }
      }
    } else {
      const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, -1, ["ner"]);
      if (enrichedNode.type === "editable-void") {
        var _enrichedNode$Constan5, _enrichedNode$Constan6, _context$trim2;
        const {
          context,
          blockIndexesUsedForContext,
          startIndex
        } = getTextAroundIndex(i, editor);
        if (((_enrichedNode$Constan5 = enrichedNode[QuantumConfig.CONTEXT_PROPERTY]) === null || _enrichedNode$Constan5 === void 0 ? void 0 : (_enrichedNode$Constan6 = _enrichedNode$Constan5.trim()) === null || _enrichedNode$Constan6 === void 0 ? void 0 : _enrichedNode$Constan6.length) > 0) forcedContext = enrichedNode[QuantumConfig.CONTEXT_PROPERTY];
        const _context = forcedContext || context;
        if (verifyAnswerIsValid(editor, enrichedNode, [i], _context)) qaData.push({
          blockIndex: i,
          context: _context,
          blockIndexesUsedForContext,
          is_impossible: enrichedNode[QuantumConfig.ANSWER_IN_CONTEXT_PROPERTY] === false || !((_context === null || _context === void 0 ? void 0 : (_context$trim2 = _context.trim()) === null || _context$trim2 === void 0 ? void 0 : _context$trim2.length) > 0),
          question: enrichedNode[QuantumConfig.QUESTION_TRAINED_PROPERTY],
          answer: enrichedNode[QuantumConfig.ANSWER_TRAINED_PROPERTY],
          startIndex: forcedContext ? 0 : startIndex
        });
      }
    }
  }
  return qaData.filter(u => {
    var _u$answer, _u$answer$trim, _u$question, _u$question$trim;
    return ((_u$answer = u.answer) === null || _u$answer === void 0 ? void 0 : (_u$answer$trim = _u$answer.trim()) === null || _u$answer$trim === void 0 ? void 0 : _u$answer$trim.length) > 0 && ((_u$question = u.question) === null || _u$question === void 0 ? void 0 : (_u$question$trim = _u$question.trim()) === null || _u$question$trim === void 0 ? void 0 : _u$question$trim.length) > 0;
  });
};
// change here
const extractGnData = editor => {
  const gnData = [];
  for (let i = 0; i < (editor === null || editor === void 0 ? void 0 : editor.children.length); i++) {
    const block = editor === null || editor === void 0 ? void 0 : editor.children[i];
    let forcedContext;
    if (block.type === "numbered-list" || block.type === "bulleted-list") {
      for (let j = 0; j < (block === null || block === void 0 ? void 0 : (_block$children3 = block.children) === null || _block$children3 === void 0 ? void 0 : _block$children3.length); j++) {
        var _block$children3;
        const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, j, ["ner"]);
        if (enrichedNode.type === "editable-void") {
          var _enrichedNode$Constan7, _enrichedNode$Constan8, _forcedContext;
          const {
            context,
            blockIndexesUsedForContext,
            startIndex
          } = getTextAroundIndex(i, editor, true);
          if (((_enrichedNode$Constan7 = enrichedNode[QuantumConfig.PROMPT_PROPERTY]) === null || _enrichedNode$Constan7 === void 0 ? void 0 : (_enrichedNode$Constan8 = _enrichedNode$Constan7.trim()) === null || _enrichedNode$Constan8 === void 0 ? void 0 : _enrichedNode$Constan8.length) > 0) forcedContext = enrichedNode[QuantumConfig.PROMPT_PROPERTY];
          const sysPrompt = enrichedNode[QuantumConfig.SYS_PROMPT_PROPERTY];
          const _context = forcedContext && ((_forcedContext = forcedContext) === null || _forcedContext === void 0 ? void 0 : _forcedContext.trim()) !== "" ? forcedContext : context;
          if (verifyPromptIsValid(editor, enrichedNode, [i, j], _context)) gnData.push({
            blockIndex: i,
            nestedIndex: j,
            prompt: "".concat(_context),
            blockIndexesUsedForContext,
            systemPrompt: sysPrompt,
            completion: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
            startIndex: forcedContext ? 0 : startIndex
          });
        }
      }
    } else {
      const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, -1, ["ner"]);
      if (enrichedNode.type === "editable-void") {
        var _enrichedNode$Constan9, _enrichedNode$Constan10, _forcedContext2;
        const {
          context,
          blockIndexesUsedForContext,
          startIndex
        } = getTextAroundIndex(i, editor, true);
        if (((_enrichedNode$Constan9 = enrichedNode[QuantumConfig.PROMPT_PROPERTY]) === null || _enrichedNode$Constan9 === void 0 ? void 0 : (_enrichedNode$Constan10 = _enrichedNode$Constan9.trim()) === null || _enrichedNode$Constan10 === void 0 ? void 0 : _enrichedNode$Constan10.length) > 0) forcedContext = enrichedNode[QuantumConfig.PROMPT_PROPERTY];
        const sysPrompt = enrichedNode[QuantumConfig.SYS_PROMPT_PROPERTY];
        const _context = forcedContext && ((_forcedContext2 = forcedContext) === null || _forcedContext2 === void 0 ? void 0 : _forcedContext2.trim()) !== "" ? forcedContext : context;
        if (verifyPromptIsValid(editor, enrichedNode, [i], _context)) gnData.push({
          blockIndex: i,
          prompt: "".concat(_context),
          blockIndexesUsedForContext,
          systemPrompt: sysPrompt,
          completion: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
          startIndex: forcedContext ? 0 : startIndex
        });
      }
    }
  }
  return gnData.filter(u => {
    var _u$completion, _u$completion$trim;
    return ((_u$completion = u.completion) === null || _u$completion === void 0 ? void 0 : (_u$completion$trim = _u$completion.trim()) === null || _u$completion$trim === void 0 ? void 0 : _u$completion$trim.length) > 0;
  });
};
const extractCnData = editor => {
  const cnData = [];
  for (let i = 0; i < (editor === null || editor === void 0 ? void 0 : editor.children.length); i++) {
    const block = editor === null || editor === void 0 ? void 0 : editor.children[i];
    if (block.type === "numbered-list" || block.type === "bulleted-list") {
      for (let j = 0; j < (block === null || block === void 0 ? void 0 : (_block$children4 = block.children) === null || _block$children4 === void 0 ? void 0 : _block$children4.length); j++) {
        var _block$children4;
        const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, j, ["ner"]);
        if (enrichedNode.type === "editable-void") {
          const {
            startIndex
          } = getTextAroundIndex(i, editor, true);
          if (enrichedNode[QuantumConfig.IS_DPO_PROPERTY]) {
            cnData.push({
              blockIndex: i,
              nestedIndex: j,
              role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
              message: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
              startIndex: startIndex,
              is_preferred: true,
              is_dpo: true
            });
            cnData.push({
              blockIndex: i,
              nestedIndex: j,
              role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
              message: "".concat(enrichedNode[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY]),
              startIndex: startIndex,
              is_preferred: false,
              is_dpo: true
            });
          } else cnData.push({
            blockIndex: i,
            nestedIndex: j,
            role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
            message: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
            startIndex: startIndex
          });
        }
      }
    } else {
      const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, -1, ["ner"]);
      if (enrichedNode.type === "editable-void") {
        const {
          startIndex
        } = getTextAroundIndex(i, editor, true);
        if (enrichedNode[QuantumConfig.IS_DPO_PROPERTY]) {
          cnData.push({
            blockIndex: i,
            role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
            message: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
            startIndex: startIndex,
            is_preferred: true,
            is_dpo: true
          });
          cnData.push({
            blockIndex: i,
            role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
            message: "".concat(enrichedNode[QuantumConfig.NON_PREFERRED_COMPLETION_TRAINED_PROPERTY]),
            startIndex: startIndex,
            is_preferred: false,
            is_dpo: true
          });
        } else cnData.push({
          blockIndex: i,
          role: enrichedNode[QuantumConfig.ROLE_PROPERTY],
          message: "".concat(enrichedNode[QuantumConfig.COMPLETION_TRAINED_PROPERTY]),
          startIndex: startIndex
        });
      }
    }
  }
  const purifiedData = [];
  lastRole = "system";
  for (let i = 0; i < cnData.length; i++) {
    var _u$message, _u$message$trim;
    const u = cnData[i];
    if (((_u$message = u.message) === null || _u$message === void 0 ? void 0 : (_u$message$trim = _u$message.trim()) === null || _u$message$trim === void 0 ? void 0 : _u$message$trim.length) > 0) {
      if (i === 0) {
        if ((u === null || u === void 0 ? void 0 : u.role) === "assistant") {
          // insert an empty user message
          purifiedData.push([{
            role: "user",
            message: " ",
            startIndex: u.startIndex
          }, {
            role: u === null || u === void 0 ? void 0 : u.role,
            message: u.message,
            startIndex: u.startIndex
          }]);
          lastRole = "user";
        } else {
          purifiedData.push({
            role: u === null || u === void 0 ? void 0 : u.role,
            message: u.message
          });
          lastRole = u === null || u === void 0 ? void 0 : u.role;
        }
      } else {
        if ((u === null || u === void 0 ? void 0 : u.role) == "system") continue;
        if ((u === null || u === void 0 ? void 0 : u.role) == lastRole && !(u !== null && u !== void 0 && u.is_dpo)) {
          // insert an empty assistant message
          purifiedData.push([{
            role: lastRole == "user" ? "assistant" : "user",
            message: " ",
            startIndex: u.startIndex
          }, {
            role: u === null || u === void 0 ? void 0 : u.role,
            message: u.message,
            startIndex: u.startIndex
          }]);
        } else {
          if (u !== null && u !== void 0 && u.is_dpo) purifiedData.push([{
            role: u === null || u === void 0 ? void 0 : u.role,
            message: u.message,
            startIndex: u.startIndex,
            isPreferred: u !== null && u !== void 0 && u.is_dpo ? u === null || u === void 0 ? void 0 : u.is_preferred : null
          }]);else purifiedData.push([{
            role: u === null || u === void 0 ? void 0 : u.role,
            message: u.message,
            startIndex: u.startIndex
          }]);
        }
        lastRole = u === null || u === void 0 ? void 0 : u.role;
      }
    }
  }
  return purifiedData.flat();
};
const extractNERfromTextNode = function (enrichedNode, matchingNER, type, i) {
  let z = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
  let relativeOffset = 0;
  for (let j = 0; j < (enrichedNode === null || enrichedNode === void 0 ? void 0 : enrichedNode.children.length); j++) {
    var _leaf$text;
    const leaf = enrichedNode === null || enrichedNode === void 0 ? void 0 : enrichedNode.children[j];
    if (leaf.type !== type) relativeOffset += leaf === null || leaf === void 0 ? void 0 : (_leaf$text = leaf.text) === null || _leaf$text === void 0 ? void 0 : _leaf$text.length;
    if (leaf.type === type) {
      const _offset = leaf === null || leaf === void 0 ? void 0 : leaf.text;
      const corePath = {
        anchor: {
          path: z !== -1 ? [i, z, j] : [i, j],
          offset: 0
        },
        focus: {
          path: z !== -1 ? [i, z, j] : [i, j],
          // offset: leaf?.children[0]?.text?.length,
          offset: _offset
        }
      };
      if (leaf.start !== leaf.end) {
        var _leaf$data;
        // get the property name from the leaf with value "true"
        const nerLabel = Object.keys(leaf).find(key => leaf[key] === true);
        matchingNER.push({
          location: {
            corePath,
            nerLabel: leaf === null || leaf === void 0 ? void 0 : (_leaf$data = leaf.data) === null || _leaf$data === void 0 ? void 0 : _leaf$data.coreNER[0],
            idx: leaf.start
          },
          domRange: {
            // CHECK BETTER
            anchor: relativeOffset,
            offset: _offset
          },
          ner: leaf,
          // CHECK BETTER
          coreNer: [nerLabel, leaf.start, leaf.end],
          blockIndex: i,
          nestedIndex: z
        });
      }
    }
  }
  return matchingNER;
};
const extractEntitiesByType = function (editor, type) {
  var _editor$children2;
  let fromBlockIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let toBlockIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : editor === null || editor === void 0 ? void 0 : (_editor$children2 = editor.children) === null || _editor$children2 === void 0 ? void 0 : _editor$children2.length;
  let matchingNER = [];
  for (let i = fromBlockIndex; i < toBlockIndex; i++) {
    const block = editor === null || editor === void 0 ? void 0 : editor.children[i];
    if (block.type === "numbered-list" || block.type === "bulleted-list") {
      for (let j = 0; j < (block === null || block === void 0 ? void 0 : (_block$children5 = block.children) === null || _block$children5 === void 0 ? void 0 : _block$children5.length); j++) {
        var _block$children5;
        block.children[j];
        const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, j, [type]);
        matchingNER = extractNERfromTextNode(enrichedNode, matchingNER, type, i, j);
      }
    } else {
      const enrichedNode = enrichElementWithAbsoluteStartEnd(editor, i, -1, [type]);
      matchingNER = extractNERfromTextNode(enrichedNode, matchingNER, type, i);
    }
  }
  return matchingNER;
};
const groupEntitiesAndIntentByID = (matchingNER, matchingIntent, editor, scope) => {
  let mergedArray = [];
  for (let i = 0; i < (editor === null || editor === void 0 ? void 0 : editor.children.length); i++) {
    var _Node$string;
    const _el = editor === null || editor === void 0 ? void 0 : editor.children[i];
    let _nerP, _intP;
    if (_el.type === "title") continue;
    if (((_Node$string = Node.string(_el)) === null || _Node$string === void 0 ? void 0 : _Node$string.trim()) === "") continue;
    if (_el.type === "numbered-list" || _el.type === "bulleted-list") {
      for (let j = 0; j < _el.children.length; j++) {
        var _intP2, _nerP2, _nerP3;
        _nerP = matchingNER.filter(ner => ner.blockIndex === i && ner.nestedIndex === j);
        _intP = matchingIntent.filter(int => int.blockIndex === i && int.nestedIndex === j);
        mergedArray.push({
          Scope: scope,
          Sentence: Node.string(_el.children[j]),
          Intent: (_intP2 = _intP) === null || _intP2 === void 0 ? void 0 : _intP2.map(i => i.intent)[0],
          Entity: (_nerP2 = _nerP) === null || _nerP2 === void 0 ? void 0 : _nerP2.map(n => n.coreNer),
          UniqueEntities: [...new Set((_nerP3 = _nerP) === null || _nerP3 === void 0 ? void 0 : _nerP3.map(n => n.coreNer).map(u => u[0]))]
        });
      }
    } else {
      var _intP3, _nerP4, _nerP5;
      _nerP = matchingNER.filter(ner => ner.blockIndex === i);
      _intP = matchingIntent.filter(int => int.blockIndex === i);
      mergedArray.push({
        Scope: scope,
        Sentence: Node.string(_el),
        Intent: (_intP3 = _intP) === null || _intP3 === void 0 ? void 0 : _intP3.map(i => i.intent)[0],
        Entity: (_nerP4 = _nerP) === null || _nerP4 === void 0 ? void 0 : _nerP4.map(n => n.coreNer),
        UniqueEntities: [...new Set((_nerP5 = _nerP) === null || _nerP5 === void 0 ? void 0 : _nerP5.map(n => n.coreNer).map(u => u[0]))]
      });
    }
  }
  return mergedArray;
};
const enrichElementWithAbsoluteStartEnd = function (editor, elementIndex) {
  var _enrichedElement$INTE;
  let listItemIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  let wrappedTypes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  let relativeStart = 0;
  let element;
  if (editor !== null && editor !== void 0 && editor.children) element = listItemIndex !== -1 ? editor === null || editor === void 0 ? void 0 : editor.children[elementIndex].children[listItemIndex] : editor === null || editor === void 0 ? void 0 : editor.children[elementIndex];else return {
    ...element,
    children: []
  };
  let enrichedElement = {
    ...element,
    children: []
  };
  for (let i = 0; i < ((_element = element) === null || _element === void 0 ? void 0 : (_element$children = _element.children) === null || _element$children === void 0 ? void 0 : _element$children.length); i++) {
    var _element, _element$children, _element2, _leaf$text2, _Node$string2;
    let leaf = {
      ...((_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.children[i])
    };
    leaf.start = relativeStart;
    if (wrappedTypes.includes(leaf.type)) leaf.end = relativeStart + (leaf === null || leaf === void 0 ? void 0 : (_leaf$text2 = leaf.text) === null || _leaf$text2 === void 0 ? void 0 : _leaf$text2.length);else leaf.end = relativeStart + ((_Node$string2 = Node.string(leaf)) === null || _Node$string2 === void 0 ? void 0 : _Node$string2.length);
    // CHECK BETTER
    relativeStart = leaf.end;
    enrichedElement.children.push(leaf);
  }
  if ((enrichedElement === null || enrichedElement === void 0 ? void 0 : (_enrichedElement$INTE = enrichedElement.INTENT) === null || _enrichedElement$INTE === void 0 ? void 0 : _enrichedElement$INTE.length) > 0) enrichedElement.INTENT = enrichedElement.INTENT.filter(u => {
    var _u$name;
    return (u === null || u === void 0 ? void 0 : u.name) && (u === null || u === void 0 ? void 0 : (_u$name = u.name) === null || _u$name === void 0 ? void 0 : _u$name.trim()) != "";
  });
  return enrichedElement;
};
const findNERPathInElement = function (editor, elementIndex) {
  let listItemIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  let wrappedTypes = arguments.length > 3 ? arguments[3] : undefined;
  let start = arguments.length > 4 ? arguments[4] : undefined;
  let end = arguments.length > 5 ? arguments[5] : undefined;
  let isExact = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  const enrichedElement = enrichElementWithAbsoluteStartEnd(editor, elementIndex, listItemIndex, wrappedTypes);
  for (let i = 0; i < enrichedElement.children.length; i++) {
    const leaf = enrichedElement.children[i];
    if (isExact && leaf.start === start && leaf.end === end || !isExact && leaf.start <= start && leaf.end >= end) if (listItemIndex !== -1) return [elementIndex, listItemIndex, i];else return [elementIndex, i];
  }
};
const generateExplicitPathFromLeafPathAndOffset = function (i, j) {
  let z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  let anchor = arguments.length > 3 ? arguments[3] : undefined;
  let offset = arguments.length > 4 ? arguments[4] : undefined;
  if (z === -1) return {
    anchor: {
      path: [i, j],
      offset: anchor
    },
    focus: {
      path: [i, j],
      // offset: leaf?.children[0]?.text?.length,
      offset: offset
    }
  };else return {
    anchor: {
      path: [i, j, z],
      offset: anchor
    },
    focus: {
      path: [i, j, z],
      // offset: leaf?.children[0]?.text?.length,
      offset: offset
    }
  };
};
const generateStringFromElement = block => {
  return Node.string(block);
};

// append text at in a new paragraph at the end of a slate document
const appendTextOnNewParagraph = (editor, text) => {
  return Transforms.insertNodes(editor, {
    type: "paragraph",
    children: [{
      text
    }],
    at: [editor.children.length]
  });
};

// append text at in a new paragraph at the end of a slate document
const appendText = (editor, text) => {
  return Transforms.insertText(editor, {
    type: "paragraph",
    children: [{
      text
    }],
    at: [editor.children.length]
  });
};
var Helpers = {
  generateExplicitPathFromLeafPathAndOffset,
  extractEntitiesByType,
  enrichElementWithAbsoluteStartEnd,
  findNERPathInElement,
  generateStringFromElement,
  extractTrainingData,
  getPlainText,
  extractRcTrainingData,
  extractGnTrainingData,
  appendText,
  appendTextOnNewParagraph,
  slateToMarkdown,
  extractCnTrainingData
};

export { Helpers as H, QuantumConfig as Q, getTextAroundIndex as g };
